import { styleOverrides } from "./styleOverrides";

const MuiRadio = {
  styleOverrides,
};

export { MuiRadio };
